module.exports = __webpack_public_path__ + "static/media/nikhil_hCo-CSG5PX.1d68d922.jpeg";